//@ts-ignore
export const theme = config.VITE_THEME as string
